import React, { FC, HTMLAttributes, ReactElement, ReactNode } from 'react'
import { CSSProperties } from 'react'

import s from '../styles.module.scss'

import FooterDesktop from '../desktop/footer-desktop/footer-desktop'
import { Container } from '../../../../components/layout'
import { Modal } from '../../../../components/molecules'
import { breakpoints, useMediaQuery } from '../../../../lib/hooks'
import { IModalFooter } from '../../../molecules/modal/Modal'

interface ILoginModalContainer {
  title?: string
  closeModal?: () => void
  style?: React.CSSProperties
  styleChildrenModal?: React.CSSProperties
  browserFooter?: IFooter
  mobileFooter?: IModalFooter
  styleContainer?: CSSProperties
  styleContent?: CSSProperties
  customHeader?: ReactNode
  mobileHeader?: ReactElement
  children: React.ReactNode
  noScroll?: boolean
}

interface IFooter extends Partial<HTMLAttributes<HTMLDivElement>> {
  label: ReactNode
  onClick: () => void
  disabled?: boolean
  isLoading?: boolean
  id?: string
}

const LoginModalContainer: FC<ILoginModalContainer> = ({
  title,
  children,
  closeModal,
  browserFooter,
  mobileFooter,
  styleContainer = {},
  styleChildrenModal,
  style,
  styleContent = {},
  customHeader,
  mobileHeader,
  noScroll,
}) => {
  const isMobile = useMediaQuery(breakpoints.newMobile)
  return (
    <Modal
      isOpen={true}
      style={{
        width: isMobile ? '100%' : 500,
        ...style,
        backgroundColor: 'white',
      }}
      styleChildren={styleChildrenModal}
      scrollbarStyle={{ padding: 0 }}
      closeModal={closeModal}
      title={title}
      styleTitle={
        isMobile ? { fontSize: '20px', lineHeight: 1 } : { fontSize: '25px' }
      }
      footer={isMobile ? mobileFooter : undefined}
      customHeader={customHeader}
      mobileHeader={mobileHeader}
      noScroll={noScroll}
    >
      <Container
        style={{ ...styleContainer, backgroundColor: 'white' }}
        styleContent={styleContent}
        className={s.containerLogin}
      >
        {children}
      </Container>
      {!isMobile && browserFooter && <FooterDesktop {...browserFooter} />}
    </Modal>
  )
}

export default LoginModalContainer
